// extracted by mini-css-extract-plugin
export default {"pageText":"thankYou_pageText__UiH9O","pageDescription":"thankYou_pageDescription__4ITLk","pageQuote":"thankYou_pageQuote__+BELT"};